import { G } from '@mobily/ts-belt';

import { B2bCashSource } from '@Common/types/bo/b2b/b2b';
import { B2bCampaignType } from '@Common/types/bo/b2b/campaigns';

export function isCampaignTypeMatchCashSource(campaignType: B2bCampaignType) {
  return campaignType !== 'withdrawal_at_maturity' && campaignType !== 'matching_contribution';
}

/**
 * Returns if a company collected choice can use this product.
 * The product must accept the cash source of the campaign.
 * For a matching contribution campaign, the product must accept the related cash source.
 * The allocation file template, the file upload and the plan select use this function.
 * This makes sure that they show and accept the same plans.
 */
export function isPlanEligibleForCampaignChoices(
  plan: { cash_sources: B2bCashSource[] },
  campaignType: B2bCampaignType,
  matchingContributionRelatedCashSource: B2bCashSource | null | undefined,
) {
  if (isCampaignTypeMatchCashSource(campaignType)) {
    return plan.cash_sources.includes(campaignType);
  }
  return (
    campaignType === 'matching_contribution' &&
    G.isNotNullable(matchingContributionRelatedCashSource) &&
    plan.cash_sources.includes(matchingContributionRelatedCashSource)
  );
}
